export default "__VITE_ASSET__XKVLxril__"